import React from 'react';
import {observer} from 'mobx-react';
import {ThemeProvider} from "styled-components";
import {SnackbarNotificationComponentBox} from "./snackbar-notification.component.box";
import {SnackbarNotificationParams} from "../../services/notifications/notifications.service";
import {HYBRID_EMBEDDED_NAV_MENU} from "../bottom-navigation-bar/bottom-navigation-bar-consts";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";

export interface SnackbarNotificationComponentWithServicesProps extends ComponentServicesPick<'dom' | 'theme'>, SnackbarNotificationParams {

}

const ComponentBody :React.FC<SnackbarNotificationComponentWithServicesProps> = observer((props) => {

    const getBottomOffset = (): number => {
        const bottomMenu = props.dom.querySelector(`.${HYBRID_EMBEDDED_NAV_MENU}`);
        return bottomMenu ? bottomMenu?.getBoundingClientRect().height : 80;
    }

    return (
        <ThemeProvider theme={props.theme.popupsTheme}>
            <SnackbarNotificationComponentBox bottomOffset={getBottomOffset()}>
                <span>
                    {props.text}
                </span>
                <span onClick={props.onCtaClick}>
                            {props.ctaText}
                </span>
            </SnackbarNotificationComponentBox>
        </ThemeProvider>
    );
});

export const SnackbarNotificationComponent = withServices(ComponentBody, ["dom", "theme"]);